<template>
  <div class="text-bar-box">
    <div v-if="text.prevId" class="bar-item">
      <label>上一期：</label>
      <a :href="'/meinvtupian/' + text.prevId + '.html'">{{ text.prevTitle }}</a>
    </div>
    <div v-if="text.nextId" class="bar-item">
      <label>下一期：</label>
      <a :href="'/meinvtupian/' + text.nextId + '.html'">{{ text.nextTitle }}</a>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      text: {
        type: Object,
        required: true
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../styles/stylefunc";

  .text-bar-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    a {
      color: #4C92E2;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TextBar.vue